import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import Loading from "../../../../components/Loading";
import Ranking from "../../../../components/Ranking";
import InterruptorRanking from "../../../../components/Ranking/Interruptor";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

/**
 * RANKING DA TURMA — visão do professor (e cargos acima), aberta pelo botão
 * na coluna de ações da lista de turmas.
 *
 * Segue o padrão do modal de Estatísticas: a lista só monta o componente
 * depois de escolhida a turma, então o `componentDidMount` já pode buscar sem
 * esperar por mudança de prop.
 *
 * Esta tela e a aba do aluno (`components/CommunityContent/ranking.js`)
 * mostram a MESMA tabela e o MESMO interruptor, os dois componentes
 * compartilhados — o que muda entre elas é só a moldura.
 */
class RankingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}gamification/ranking`, {
        params: { room_id: this.props.room_id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ data: resp.data.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
        toastr.error("Erro", "Não foi possível carregar o ranking da turma.");
      });
  }

  definirVisibilidade = valor => {
    this.setState(state => ({
      data: { ...state.data, visible_to_students: valor }
    }));
  };

  render() {
    return (
      <CModal
        size="lg"
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Ranking da turma - {this.props.name}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : (
            <>
              {this.state.data && this.state.data.can_manage && (
                <InterruptorRanking
                  roomId={this.props.room_id}
                  checked={this.state.data.visible_to_students}
                  onChange={this.definirVisibilidade}
                />
              )}
              <Ranking data={this.state.data} />
            </>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(RankingModal);
